import React, { Component } from 'react';
import OptionButtonEvent from './OptionButtonEvent';
import * as api from '../../../requests/loader';
import favoriteTask from '../../../requests/tasks/ficha/favoriteTask';
import RequestManager from '../../../requests/RequestManager';
import * as userFilters from '../../../containers/MyContent/settings';
import Asset from '../../../requests/apa/Asset';
import Translator from '../../../requests/apa/Translator';
import LoadFav from '../../../AAF/LoaderExp/LoadFav';
import { RibbonsObserver, UpdateMiniObserver } from '../../../components/PersistentMiniEpg/MiniObserver';

class FavoriteEvent extends Component {
    constructor(props = {}) {
        super(props);
        this.groupId = (this.props && this.props.data && this.props.data.group_id) || null;
        this.state = {
            isFavorite: false,
        };
        this.imageButton_favorite = Asset.get('playingLive_program_option_button_favorites', '/images/ic_favorite.png');
        this.history = props && props.history || null;
    }

    componentDidMount() {
        this.isFavorite();
    }

    callBackGreen = (e) =>{ 
        e && e.preventDefault && e.preventDefault();
        e && e.stopPropagation && e.stopPropagation();
        e && e.stopImmediatePropagation && e.stopImmediatePropagation();
        let urlMyContent = false;
        if(typeof this.props.getLinks === 'function'){
            const urls = this.props.getLinks();
            urlMyContent = urls && urls.miscontenidos && `/node/${urls.miscontenidos}`;
        }
        if(!urlMyContent) return;
        (typeof this.props.stopPlayer === 'function') && this.props.stopPlayer();
        this.history && this.history.push && (typeof this.history.push === 'function') && this.history.push(urlMyContent);
    }


    componentWillMount() {}

    async isFavorite() {
        if(LoadFav.isFavorite(this.groupId)){
            this.setState({ isFavorite: true });
        }else{
            this.setState({ isFavorite: false });
        }
    }

    showToggleFavoritedChannelNotification = (isFavorite) =>{
        if(this.props && this.props.showToggleFavoritedChannelNotification && (typeof this.props.showToggleFavoritedChannelNotification === 'function')){
            this.props.showToggleFavoritedChannelNotification(isFavorite, this.callBackGreen);
        }
    }

    handleAddFavorite = () => {
        // this.sendMetric('agregar a mi lista');
        const task = new favoriteTask({
            object_id: this.groupId,
            object_type: 1,
            user_hash: this.props.user.session_userhash,
            live: true,
        });
        RequestManager.addRequest(task)
            .then((data) => {
                if (data.lasttouch && data.lasttouch.favorited) {
                    const lastTouchFav = data.lasttouch.favorited;
                    this.props && this.props.updateLastTouchFavorited && this.props.updateLastTouchFavorited(lastTouchFav);
                }

                // this.props.updateFavorite(this.state.favoriteData);
                if (data.response) {
                    RibbonsObserver.fire(false);
                    LoadFav.addFav(this.groupId);
                    this.props && (typeof this.props.sendMetric === 'function') && this.props.sendMetric('añadir canal a favoritos');
                    this.showToggleFavoritedChannelNotification(true);
                    this.setState({ isFavorite: true });
                    UpdateMiniObserver.fire(null);
                }
                this.handleClose();
            })
            .catch((e) => {
                this.handleClose();
            });
    };

    handleClose = () => {
        this.props && this.props.handleClose && (typeof this.props.handleClose) && this.props.handleClose();
    }

    handleDeleteFavorite = () => {
        api.deleteFavorite(this.groupId, true)
            .then((resp) => {
                if (resp.lasttouch && resp.lasttouch.favorited) {
                    const lastTouchFav = resp.lasttouch.favorited;
                    this.props && this.props.updateLastTouchSeen && this.props.updateLastTouchSeen(lastTouchFav);
                    this.props && this.props.updateLastTouchFavorited && this.props.updateLastTouchFavorited(lastTouchFav);
                }
                if (resp.response && resp.status === '0') {
                    RibbonsObserver.fire(false);
                    LoadFav.deleteFav(this.groupId);
                    this.showToggleFavoritedChannelNotification(false);
                    this.setState({ isFavorite: false });
                    UpdateMiniObserver.fire(null);
                    this.handleClose();
                } else {
                    // TODO
                }
            })
            .catch((e) => {
                console.log('[FAVORITE]-cath', e);
                this.handleClose();
                // TODO
            });
    };

    render() {
        const { isFavorite } = this.state;
        const { user = {} } = this.props; 
        if(user && user.isAnonymous){
            return null
        }

        return isFavorite ? (
            <OptionButtonEvent title={Translator.get('panelOptions_sidemenu_item_channel_button_deleteFavorite','Eliminar canal de favoritos')} onClick={this.handleDeleteFavorite} image={this.imageButton_favorite}/>
        ) : (
            <OptionButtonEvent title={Translator.get('panelOptions_sidemenu_item_channel_button_addFavorite','Añadir canal a favoritos')} onClick={this.handleAddFavorite} image={this.imageButton_favorite}/>
        );
    }
}

export default FavoriteEvent;



// WEBPACK FOOTER //
// ./src/components/EventOptions/components/FavoriteEvent.jsx